import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import VerticalNavBar from "../VerticalNavBar";
import ExpandableCard from "./DayCard";
import Particle from "../Particle";

import styled from "styled-components";
import SearchForm from "./forms/searchForm"; // Import the SearchForm component
import API from "../../utils/api";

const StyledRow = styled(Row)`
  padding-bottom: 1.25rem;
`;

function DayToDayLearning(props) {
  props.setLearning(true);
  const [data, setData] = useState([]);

  useEffect(() => {
    // Load initial data on component mount
    API.get("/api/learning/getLearning")
      .then((res) => res.data)
      .then((response) => {
        setData(response.learnings);
      })
      .catch((error) => {
        console.error("There was an error fetching the initial data!", error);
      });
  }, []);

  const handleDateChange = (newData) => {
    setData(newData.learnings); // Update data based on date range picker response
  };

  return (
    <>
      <Particle />
      <Container fluid className="resume-section">
        <StyledRow>
          <VerticalNavBar
            setIsAuthenticated={props.setIsAuthenticated}
            setLearning={props.setLearning}
          />
          <SearchForm onDataChange={handleDateChange} />
        </StyledRow>
        {data.map((item, index) => (
          <StyledRow
            key={index}
            style={{
              padding: window.innerWidth < 768 ? "0.5rem" : "0.5rem 2rem",
            }}
          >
            <ExpandableCard
              date={item.date}
              title={item.title}
              text={item.description}
              link={item.link}
            />
          </StyledRow>
        ))}
      </Container>
    </>
  );
}

export default DayToDayLearning;
